import styled from "styled-components";

// Container for the News section
export const Container = styled.div`
  width: auto;
  max-width: 100%;  /* Allow the container to expand based on the screen size */
  margin: 0 auto;
  padding: 20px;
  text-align: center;
`;

// Header for the News section, adjusted for alignment
export const NewsHeader = styled.h2`
  font-size: 5vw;  /* Responsive font size based on viewport width */
  margin-bottom: 0; /* Removed bottom margin to prevent extra space */
  padding-bottom: 15px; /* Adjusted padding to align header closer to content */
  line-height: 1.5;  /* Ensures the header takes up less space vertically */
  text-align: center;  /* Keeps the header centered */
`;

// Content for the News section
export const NewsContent = styled.div`
  margin-top: 20px;
  p {
    font-size: 3vw;  /* Responsive font size based on viewport width */
    color: #333;
    margin: 0 auto; /* Ensure text is centered within the container */
    max-width: 100%; /* Prevent text from overflowing */
  }
`;

// Carousel container with responsiveness
export const CarouselContainer = styled.div`
  position: relative;
  width: 100%;
  height: 350px;  /* Default height */
  max-width: 100%;  /* Ensure it doesn't exceed screen width */
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;  /* Center the carousel */
`;

// Flex container for the carousel images
export const CarouselImages = styled.div`
  display: flex;
  transition: transform 0.5s ease-in-out;
  width: 100%;
`;

// Smart carousel image styling
export const CarouselImage = styled.img`
  width: auto;          /* Make the image fill the width of the container */
  height: auto;         /* Make the image fill the height of the container */
  object-fit: cover;    /* Cover the area while maintaining the aspect ratio */
  max-width: 100%;      /* Ensure the image doesn't stretch beyond its container */
  max-height: 350px;    /* Limit the maximum height to avoid oversized images */
  object-position: center;  /* Center the image within the container */
`;

export const ArrowButton = styled.button`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(0, 0, 0, 0.5);
  color: white;
  border: none;
  font-size: 2rem;
  cursor: pointer;
  z-index: 1;

  &.prev {
    left: 10px;
  }

  &.next {
    right: 10px;
  }
`;
